import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Page from "../shared/components/PageComponent";
import openFile from "../shared/functions/download";
import TeilnahmeForm from "./Formulare/TeilnahmeForm";
import VstUebersicht from "./VstUebersicht";

const program = "HVATAN";

function VstAnmeldung(props) {
  const { t } = useTranslation();
  const { user, updateTitle, accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage } = useMessage();
  const [userAuswahl, setUserAuswahl] = useState();
  const [aktUser, setAktUser] = useState(user.id);
  const [aktEvent, setAktEvent] = useState({});
  const [list, setList] = useState([]);
  const [aktVeranstaltung, setAktVeranstaltung] = useState({});
  const [expanded, setExpanded] = useState(false);

  const [showAuswertungsForm, setShowAuswertungsForm] = useState(false);
  const [showTeilnahmeForm, setShowTeilnahmeForm] = useState(false);
  const [showInVerwaltungForm, setShowInVerwaltungForm] = useState(false);
  const [showTnVerwaltungForm, setShowTnVerwaltungForm] = useState(false);

  const [teilnahmeFormData, setTeilnahmeFormData] = useState({});

  useEffect(() => {
    updateTitle("Veranstaltungs Anmeldung");
    init();
    datenHolen();
  }, []);

  // Requests und Datenaustausch
  const init = () => {
    setIsLoading(true);

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: program,
      statement: "INIT",
    };

    apiRequest("POST", "daten", payload, headers, initCb, errorCb);
  };

  const initCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setUserAuswahl(response.data.user);
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const datenHolen = () => {
    // setIsLoading(true);

    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: program,
      statement: "DATEN_HOLEN",
      userOid: aktUser,
    };

    apiRequest("POST", "daten", payload, headers, datenCb, errorCb);
  };

  const datenCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setList(response.data.event);
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const tnStatusSetzen = (vst, status, kommi) => {
    // setIsLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: program,
      statement: "TEILNAHME_STATUS_SETZEN",
      userOid: aktUser,
      vstnr: vst,
      status: status,
      kommentar: kommi,
    };

    apiRequest("POST", "daten", payload, headers, tnStatusCb, errorCb);
  };

  const tnStatusCb = (response) => {
    if (response.status === 200) {
      datenHolen();
      setShowTeilnahmeForm(false);
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const wartelisteUpdate = (daten) => {
    setIsLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: program,
      statement: "PERSONEN_UPDATE",
      vstnr: aktEvent.eventnr + "000",
      daten: daten,
    };

    apiRequest("POST", "daten", payload, headers, wartelisteCb, errorCb);
  };

  const wartelisteCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const handlePdfDownload = (vst) => {
    const payload = {
      mandant: client,
      program: program,
      statement: "EINLADUNG_DOWNLOAD",
      vstnr: vst.vstnr,
      einladung: vst.docnr,
    };

    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(vst.fileName, contentFile, mimeType);
      })
      .catch(function (error) {
        setExpanded(false);
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den Download erneut.");
      });
  };

  const handleTerminDownload = (vst) => {
    const payload = {
      mandant: client,
      program: program,
      statement: "TERMIN_DOWNLOAD",
      vstnr: vst.vstnr,
    };

    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(vst.info, contentFile, mimeType);
      })
      .catch(function (error) {
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den Download erneut.");
      });
  };

  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."));
  };

  // Funktionen

  function handleTeilnahmeStatus(vst, status) {
    setTeilnahmeFormData({ vst: vst, status: status });
    setShowTeilnahmeForm(true);
  }

  function handleAction(action, props) {
    // Aktion ausführen
    switch (action) {
      case "interesse":
        tnStatusSetzen(props, "0");
        break;
      case "termin_download":
        handleTerminDownload(props);
        break;
      case "einladung_download":
        handlePdfDownload(props);
        break;
      case "anmelden":
        tnStatusSetzen(props, "0");
        break;
      case "abmelden":
        tnStatusSetzen(props, "X");
        break;
      case "teilgenommen":
        handleTeilnahmeStatus(props, "1");
        break;
      case "gefehlt":
        handleTeilnahmeStatus(props, "2");
        break;
      case "warteliste_verwalten":
        setAktEvent(props);
        setShowInVerwaltungForm(true);
        break;
      case "teilnehmer_verwalten":
        setAktVeranstaltung(props);
        setShowTnVerwaltungForm(true);
        break;
      case "ma_auswerten":
        // auswertungsFormData.reset();
        // auswertungsFormData.setValue("aw_art", props);
        setShowAuswertungsForm(true);
        break;
      case "reload":
        datenHolen();
        break;
      default:
        showErrorMessage("Unbekannte Aktion '" + action + "' gewählt!");
        break;
    }
  }

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <Page>
      <TeilnahmeForm formData={teilnahmeFormData} openState={showTeilnahmeForm} stateChange={setShowTeilnahmeForm} onSubmit={tnStatusSetzen} />

      {/* Vorgesetzten Formulare sind teilweise Vorbereitet falls es gewünscht wird das die Verwaltung als Vorgesetzter auch aus der App geht */}
      {/* <WartelisteVerwaltungForm
        openState={showInVerwaltungForm}
        stateChange={setShowInVerwaltungForm}
        onSubmit={wartelisteUpdate}
        event={aktEvent}
        userAuswahl={userAuswahl}
      />

      <TeilnehmerVerwaltungForm
        openState={showTnVerwaltungForm}
        stateChange={setShowTnVerwaltungForm}
        onSubmit={teilnehmerUpdate}
        veranstaltung={aktVeranstaltung}
        userAuswahl={userAuswahl}
      />

      <AuswertungsForm
        formData={auswertungsFormData}
        openState={showAuswertungsForm}
        stateChange={setShowAuswertungsForm}
        onSubmit={maAuswertung}
        userAuswahl={userAuswahl}
      /> */}

      <VstUebersicht list={list} onAction={handleAction} userAuswahl={userAuswahl} expanded={expanded} setExpanded={setExpanded}></VstUebersicht>
    </Page>
  );
}
export default VstAnmeldung;
